// src/components/navigation/MobileBottomNav.tsx

import React from "react";

import type { NavItem } from "../../types/navbar.types";

interface MobileBottomNavProps {
  navItems: NavItem[];
  isActive: (path: string) => boolean;
  onNavigate: (path: string) => void;
}

export const MobileBottomNav: React.FC<
  MobileBottomNavProps
> = ({
  navItems,
  isActive,
  onNavigate,
}) => {
  return (
    <nav
      aria-label="Mobile navigation"
      className="
        fixed inset-x-0 bottom-0 z-40
        border-t border-[#E4EFED]
        bg-white
        md:hidden
      "
    >
      <div className="flex h-16 items-stretch px-1">
        {navItems.map((item) => {
          const itemIsActive = isActive(item.path);

          return (
            <button
              key={item.path}
              type="button"
              onClick={() => onNavigate(item.path)}
              aria-current={
                itemIsActive ? "page" : undefined
              }
              aria-label={`Navigate to ${item.label}`}
              className={[
                "relative flex min-w-0 flex-1 flex-col",
                "items-center justify-center gap-1",
                "px-1 text-center",
                "transition-colors",
                "focus-visible:outline-none",
                "focus-visible:ring-2",
                "focus-visible:ring-inset",
                "focus-visible:ring-[#159A92]",
                itemIsActive
                  ? "text-[#117E78]"
                  : "text-[#65777C]",
              ].join(" ")}
            >
              <item.icon
                className={[
                  "h-5 w-5 shrink-0",
                  itemIsActive
                    ? "text-[#159A92]"
                    : "text-[#7D9094]",
                ].join(" ")}
                strokeWidth={itemIsActive ? 2.25 : 2}
                aria-hidden="true"
              />

              <span
                className={[
                  "max-w-full truncate text-[11px] leading-none",
                  itemIsActive
                    ? "font-semibold text-[#117E78]"
                    : "font-medium text-[#65777C]",
                ].join(" ")}
              >
                {item.label}
              </span>

              {itemIsActive && (
                <span
                  className="
                    absolute bottom-1 h-1 w-1
                    rounded-full bg-[#159A92]
                  "
                  aria-hidden="true"
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;